var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.219668 0.219668C-0.0732225 0.512558 -0.0732225 0.987438 0.219668 1.28033L6.9393 8L0.219668 14.7197C-0.0732225 15.0126 -0.0732225 15.4874 0.219668 15.7803C0.512558 16.0732 0.987437 16.0732 1.28033 15.7803L8.5303 8.5303C8.8232 8.2374 8.8232 7.7626 8.5303 7.4697L1.28033 0.219668C0.987437 -0.0732225 0.512558 -0.0732225 0.219668 0.219668Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/NextArrow.5b237277c7f0e895d4e2cb586ad54a56.svg";
export { ForwardRef as ReactComponent };